import Swiper from "swiper/bundle";
import $ from "jquery";

const swiperSlider = {
    variables: {
        swiperContainer: ".swiper-container",
        pagination: ".custom-pagination",
        navigationPrev : ".custom-navigation-prev",
        navigationNext : ".custom-navigation-next"
    },
    methods: {
        initializerSwiper: function (swiperElement, swiperOptions) {
            $(swiperElement).each((index, element) => {
                const customPagination = $(element)
                    .closest(swiperSlider.variables.swiperContainer)
                    .find(swiperSlider.variables.pagination);
                const customNavigationPrev = $(element)
                    .closest(swiperSlider.variables.swiperContainer)
                    .find(swiperSlider.variables.navigationPrev);
                const customNavigationNext = $(element)
                    .closest(swiperSlider.variables.swiperContainer)
                    .find(swiperSlider.variables.navigationNext);
                let swiperConfig = {
                    ...swiperOptions,
                    pagination: {
                        el: customPagination[0],
                        clickable: true,
                    },
                    navigation: {
                        nextEl: customNavigationNext[0],
                        prevEl: customNavigationPrev[0],
                        disabledClass: 'disabled',
                    },
                };
                let swiper = new Swiper(element, swiperConfig);
                if($(customNavigationNext).hasClass('disabled') && $(customNavigationPrev).hasClass('disabled')){
                    $(customNavigationNext).hide();
                    $(customNavigationPrev).hide();
                }
                return swiper;
            });
        },
    },
};

export default swiperSlider;
